import { Paper } from '@material-ui/core';
import * as React from 'react';

const DragDrop: React.FC<{
  handleFile: (file: File) => void,
}> = (
  {
    handleFile, children,
  },
) => {
  const suppress = (e:React.DragEvent) => { e.stopPropagation(); e.preventDefault(); };
  const handleDrop = (e:React.DragEvent) => {
    e.stopPropagation(); e.preventDefault();
    const { files } = e.dataTransfer;
    if (files && files[0]) handleFile(files[0]);
  };

  return (
    <Paper
      onDrop={handleDrop}
      onDragEnter={suppress}
      onDragOver={suppress}
      elevation={4}
      variant="outlined"
      style={{ backgroundColor: '#fafafa', padding: '1rem' }}
    >
      {children}
    </Paper>
  );
};
export default DragDrop;
